import { SecLoansApplicationSelectData as FormData } from '@sec-loans-ui/common/types'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, only, Suite, test } from 'vest'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: Partial<FormData>, changedFields?: FieldName<FormData>[]) => void> =>
  create((data, changedFields) => {
    only(changedFields)

    test('applicationType', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.applicationType).isNotUndefined()
      enforce(data.applicationType).isNotEmpty()
    })

    test('applicationPurpose', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.applicationType).isNotUndefined()
      enforce(data.applicationPurpose).isNotEmpty()
    })
  })
